// Deprecated
// TODO: remove

export enum EditorControls {
    pan = 1,
    regionSelect = 2,
    drawAll = 3,
    drawVisible = 4,
    drawOnPoly = 5,
    drawOnTexture = 6,
    measuringPoints = 7,
    editPointPostion = 8,
    reset = 9,
    resetDraw = 10,
    drawOnPolyRect = 11,
    drawOnTextureRect = 12,
    erase = 13,
    drawOnTextureBrush = 14,
    measure = 15,
    clearImage = 16,
    dragImage = 17,
    resetImage = 18,
    placeLandmarks = 19,
    info = 20,
    resetTransformations = 21,
    placeSensor = 22,
    selectSensor = 23,
    makeAnnotations = 24,
    custom = 25
}

export enum DrawModes {
    pan = 'false',
    regionSelect = 'false',
    drawAll = 'true',
    drawVisible = 'true',
    drawOnPoly = 'true',
    drawOnTexture = 'true',
    measuringPoints = 'false',
    editPointPostion = 'false',
    reset = 'false',
    resetDraw = 'false',
    drawOnPolyRect = 'true',
    drawOnTextureRect = 'true',
    erase = 'true',
    drawOnTextureBrush = 'true',
    measure = 'true',
    clearImage = 'false',
    dragImage = 'false',
    resetImage = 'false',
    info = 'false',
    placeLandmarks = 'true',
    resetTransformations = 'false',
    placeSensor = 'true',
    selectSensor = 'true',
    makeAnnotations = 'false',
    custom = 'false'
}


